module.exports = __webpack_public_path__ + "static/media/pw-coins-active-icon.3eb25929.svg";